// banner 配置
export const banner = {
  // cover: 'https://img.alicdn.com/tfs/TB1exgPxhn1gK0jSZKPXXXvUXXa-1920-757.jpg',
  // mcover: 'https://gw.alicdn.com/tfs/TB1PbycM7voK1RjSZFNXXcxMVXa-750-320.png',
  title: {
    loginTitle: '让健康触手可得',
    text: '用大数据助力医疗，用互联网改变健康',
  },
};
